/**
 * The Small Wins Wall. A33.
 *
 * Chips narrow the wins already on the page; "Cancel" closes the door the
 * form opened behind. Both work without this file — the chips simply show
 * everything and the door is a <details> — this only makes them quicker.
 */

const wall = document.querySelector('[data-wall]');
if (wall) {
  const bar = wall.querySelector('[data-wall-bar]');
  const wins = [...wall.querySelectorAll('[data-win]')];

  bar?.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-cat]');
    if (!chip) return;
    bar.querySelectorAll('[data-cat]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
    const cat = chip.dataset.cat;
    wins.forEach((win) => (win.hidden = Boolean(cat) && win.dataset.cat !== cat));
  });

  wall.addEventListener('click', (event) => {
    const cancel = event.target.closest('[data-wall-cancel]');
    if (!cancel) return;
    const door = cancel.closest('[data-wall-door]');
    if (door) door.open = false;
  });
}
